import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        if (!this.props.deck) {
            this.props.requireDeck();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.deck != this.props.deck) {
            return true;
        }

        return false;
    }

    render({ deck }) {
        if (deck) {
            return (
                <tarot-card-browser>
                    <h2 className='is-h1'>Learn Tarot</h2>
                    <p>
                        Explore the meaning of any Tarot card while browsing our extensive library of Tarot decks!
                        Start by choosing any card below:
                    </p>
                    <row className='is-wrap'>
                        <column className='is-12'>
                            <h5>Major Arcana</h5>
                        </column>
                        {deck.cards.slice(0, 22).map(card => {
                            return (
                                <column className='is-6'>
                                    <a href={`/tarot/cards/${card.canonical_rank}`}>
                                        {card.name}
                                    </a>
                                </column>
                            );
                        })}
                    </row>
                    <br />
                    <row>
                        <column className='is-6'>
                            <h5>Wands</h5>
                            <row className='is-wrap'>
                                {deck.cards.slice(22, 36).map(card => {
                                    return (
                                        <column className='is-12'>
                                            <a href={`/tarot/cards/${card.canonical_rank}`}>
                                                {card.name}
                                            </a>
                                        </column>
                                    );
                                })}
                            </row>
                        </column>
                        <column className='is-6'>
                            <h5>Cups</h5>
                            <row className='is-wrap'>
                                {deck.cards.slice(36, 50).map(card => {
                                    return (
                                        <column className='is-12'>
                                            <a href={`/tarot/cards/${card.canonical_rank}`}>
                                                {card.name}
                                            </a>
                                        </column>
                                    );
                                })}
                            </row>
                        </column>
                    </row>
                    <br />
                    <row>
                        <column className='is-6'>
                            <h5>Swords</h5>
                            <row className='is-wrap'>
                                {deck.cards.slice(50, 64).map(card => {
                                    return (
                                        <column className='is-12'>
                                            <a href={`/tarot/cards/${card.canonical_rank}`}>
                                                {card.name}
                                            </a>
                                        </column>
                                    );
                                })}
                            </row>
                        </column>
                        <column className='is-6'>
                            <h5>Coins</h5>
                            <row className='is-wrap'>
                                {deck.cards.slice(64, 78).map(card => {
                                    return (
                                        <column className='is-12'>
                                            <a href={`/tarot/cards/${card.canonical_rank}`}>
                                                {card.name}
                                            </a>
                                        </column>
                                    );
                                })}
                            </row>
                        </column>
                    </row>
                </tarot-card-browser>
            );
        }

        return (<tarot-card-browser />);
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
});

const mapDispatchToProps = (dispatch) => ({
    requireDeck: () => dispatch({ type: 'deck:required', payload: 'universal_waite' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
